import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

import styles from './title-activity.style';
import VocabularyDisplay from './vocabulary-display';
import { useActivityContext } from '../../../../hooks/use-activity.context';
import LessonAccentBanner from '../../../lesson-accent-banner/lesson-accent-banner';
import LessonImage from '../../../lesson-image/lesson-image';
import LessonInstructions from '../../../lesson-instructions/lesson-instructions';
import LessonPlayerFrame from '../../../lesson-player-frame/lesson-player-frame';
import ThemedText2 from '../../../themed-text-2';
import TranslatableHTML from '../../../translatable-html';
import TranslatableText2 from '../../../translatable-text2';

interface TitleActivityInterface {
  type: 'TITLE' | 'TITLE - EXTENDED';
  title?: string;
  vocabulary?: string;
  objective?: string;
  objectiveTranslation?: string;
  summary?: string;
  summaryTranslation?: string;
  image?: string;
}

export function TitleActivity() {
  const { t } = useTranslation();
  const activityContext = useActivityContext();
  const { completeCurrentActivity, isCurrentActivityComplete } =
    activityContext;
  const currentActivity =
    activityContext.currentActivity as TitleActivityInterface;

  useEffect(() => {
    completeCurrentActivity();
  }, [completeCurrentActivity]);

  return (
    <LessonPlayerFrame
      isButtonStuck={false}
      showContinueButton={isCurrentActivityComplete}
    >
      <LessonAccentBanner>
        <LessonInstructions style={styles.title}>
          {currentActivity.title}
        </LessonInstructions>
      </LessonAccentBanner>
      <LessonImage imageUrl={currentActivity?.image} style={styles.image} />
      <View style={styles.content}>
        <View style={styles.innerContent}>
          <TranslatableText2
            style={styles.objective}
            translation={currentActivity.objectiveTranslation}
          >
            {currentActivity.objective}
          </TranslatableText2>
          <TranslatableHTML
            style={styles.summary}
            translation={currentActivity.summaryTranslation}
          >
            {currentActivity.summary}
          </TranslatableHTML>
          {!!currentActivity.vocabulary && (
            <>
              <ThemedText2
                style={styles.vocabulary}
                fontWeightStyle="bold"
                fontSize={12}
              >
                {t('vocabulary')}
              </ThemedText2>
              <VocabularyDisplay vocabulary={currentActivity.vocabulary} />
            </>
          )}
        </View>
      </View>
    </LessonPlayerFrame>
  );
}
